import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { useHistory } from 'react-router-dom'

import { hideMaintenanceRecord } from '../../../store/asset/actions'

import styles from './styles.module.scss'

import { CrossIcon, AttachmentIcon } from '../Icons'

const MaintenanceRecordDetails = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const {show, data: record} = useSelector(state => state.asset.maintenanceRecord)

  const [showLayout, setShowLayout] = useState(false)

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShowLayout(true)
      }, 100)
    } else {
      setShowLayout(false)
    }
  }, [show])

  const handleClose = () => {
    dispatch(hideMaintenanceRecord())
  }

  const handleOpenAsset = () => {
    history.push({search: `?tab=${record.asset_id}`})
    handleClose()
  }

  const { photos, attachments } = (record.documents || []).reduce((acc, doc) => {
    if (doc.type === 'photo') {
      acc.photos.push(doc)
    } else {
      acc.attachments.push(doc)
    }
    return acc
  }, {photos: [], attachments: []})

  return (
    <>
      {
        show
          ? <div className={cn(styles.layout, {[styles.active]: showLayout})} onClick={handleClose} />
          : null
      }
      <div className={cn(styles.container, {[styles.active]: show})}>
        <div className={styles.header}>
          <div className={styles.headerTitle}>{record.maintenance_plan?.name || t('Unplanned repair')}</div>
          <button type="button" className={styles.closeButton} onClick={handleClose}>
            <CrossIcon />
          </button>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            {record.asset?.name} · { moment(record.date).format('YYYY-MM-DD') }
          </div>
          <div className={styles.row}>
            <div className={styles.rowLabel}>{t('Performed by:')}</div>
            <div className={styles.rowValue}>{record.employee?.name} {record.employee?.surname || ''}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.rowLabel}>{t('Supplier:')}</div>
            <div className={styles.rowValue}>{record.supplier}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.rowLabel}>{t('Invoice:')}</div>
            <div className={styles.rowValue}>{record.invoice_number}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.rowLabel}>{t('Cost:')}</div>
            <div className={styles.rowValue}>{record.cost}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.rowLabel}>{t('Work performed:')}</div>
            <div className={styles.rowValue}>{record.work_performed}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.rowLabel}>{t('Notes:')}</div>
            <div className={styles.rowValue}>{record.notes}</div>
          </div>
          {
            photos.length
              ? <div className={styles.section}>
                  <div className={styles.sectionTitle}>{t('Photos')}</div>
                  <div className={styles.attachmentList}>
                    {
                      photos.map((doc, i) => {
                        return (
                          <div key={i} className={styles.photoContainer}>
                            <a href={doc.url} target="_blank" rel="noopener noreferrer">
                              <img src={doc.url} alt={`Photo ${i + 1}`} />
                            </a>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              : null
          }
          {
            attachments.length
              ? <div className={styles.section}>
                  <div className={styles.sectionTitle}>{t('Attachments')}</div>
                  <div className={styles.attachmentList}>
                    {
                      attachments.map((doc, i) => {
                        return (
                          <div key={i} className={styles.attachmentContainer}>
                            <AttachmentIcon />
                            <a href={doc.url} target="_blank" rel="noopener noreferrer">{doc.name || `Attachment ${i + 1}`}</a>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              : null
          }
          <div>
            <button type="button" className={styles.openAssetButton} onClick={handleOpenAsset}>{t('Open asset')}</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default MaintenanceRecordDetails
